import { Ellipsis } from 'components/elements/Ellipsis';
import { styled } from 'styles';

export const CardStatusItem = styled.div`
  background-color: ${({ theme }) => theme.card.status.item.background};
  border-radius: ${({ theme }) => theme.radius.small};
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.relative.tiny}
    ${({ theme }) => theme.spacing.relative.small};
  transition: background-color ${({ theme }) => theme.transition.fast} ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.card.status.item.hover.background};
  }

  @media (max-width: 576px) {
    grid-template-columns: 50% 50%;
  }
`;

export const CardStatusLabel = styled(Ellipsis)`
  font-size: 0.9em;
  font-weight: 500;
  white-space: nowrap;
`;

export const CardStatusValue = styled(Ellipsis)`
  font-weight: 600;
`;

export const StyledCardStatus = styled.div`
  background-color: ${({ theme }) => theme.card.status.background};
  color: ${({ theme }) => theme.card.status.color};
  cursor: default;
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.absolute.small};
  grid-template-columns: repeat(auto-fit, minmax(11em, 1fr));
  line-height: 1.4em;
  padding: ${({ theme }) => theme.spacing.absolute.small};
  user-select: none;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 400px) {
    display: none;
  }
`;

CardStatusValue.displayName = 'CardStatusValue';
StyledCardStatus.displayName = 'CardStatus.Styled';
